import {deleteSubstitutionAction} from "../deleteSubstitution.action";
import { $api } from "../../../../services/request.config";

export const deleteSubstitutionThunkAction = ({id, statusModal, setStatusModal}) => async (dispatch) => {
    try {
        const response = await $api.delete(`v1/manager/substitutions/${id}`);
        // console.log("RESPONSE DELETE: ", response)
        if (response.status === 204) {
            dispatch(deleteSubstitutionAction(id));
            setStatusModal({status: false, loading: false,  message: "", delete: false});
        }
    } catch (error) {
        setStatusModal({...statusModal, loading: false});
        if (error.response.status === 404) {
            return     setStatusModal({delete: false, status: true, loading: false, message: "Замещение не найдено"});
        }else if (error.response.status === 422) {
            return  setStatusModal({delete: false, status: true, loading: false, message: `${error.response.data.detail}`});
        } else {
            return     setStatusModal({delete: false, status: true, loading: false, message: "Ошибка при удалении замещения"});
        }
        // console.log("ERROR WHILE DELETING REPLACEMENT: ", error.response)
    }
};
